import React, { useEffect, useRef, useState } from 'react';

////const useOnclickOutside = ({ ref, handler }) => {
////    return useEffect(() => {

////        const listener = (event) => {
////            debugger
////            if (!ref.current || ref.current.contains(event.target)) return;
////            handler(event);
////        };

////        window.addEventListener('click', listener);
////        window.addEventListener('touchstart', listener);

////        return () => {
////            window.removeEventListener('click', listener);
////            window.removeEventListener('touchstart', listener)
////        }

////    }, [ref, handler])
////}

//export const Dropdown = ({ title, children, className }) => {
//    const [isOpen, setIsOpen] = useState(false);
//    const ref = useRef();

//    const close = () => { alert('close'); setIsOpen(false); }

//    useEffect(() => {

//        const listener = (event) => {

//            if (isOpen && !ref.current.contains(event.target)) {
//                setIsOpen(false);
//            }
//        };

//        window.addEventListener('click', listener);
//        window.addEventListener('touchstart', listener);

//        return () => {
//            window.removeEventListener('click', listener);
//            window.removeEventListener('touchstart', listener)
//        }

//    }, [isOpen])

//    const menu = {
//        position: 'absolute',
//        padding: '0px 0',
//        background: '#fffffff2',
//        borderRadius: '10px',
//        border: '1px solid #c8c8c8',
//        overflow: 'hidden',
//        marginLeft: '-50px',
//        marginTop: '6px',
//        boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
//        backdropFilter: 'blur(1px)',
//    }
//    return (
//        <div ref={ref} className={`dropdown ${isOpen ? "open" : ""}`} style={{ display: 'inline-block' }}>
//            <button onClick={() => setIsOpen(!isOpen)} className={className} >
//                {title}
//            </button>
//            <div className="menu" style={{ display: isOpen ? 'grid' : 'none', ...menu }}>
//                {children}
//            </div>
//        </div>)
//}

export class Dropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
        this.ref2 = this.props.innerRef || React.createRef();
        this.menu = {
            position: 'absolute',
            padding: '0px 0',
            background: '#fffffff2',
            borderRadius: '10px',
            border: '1px solid #c8c8c8',
            overflow: 'hidden',
            marginLeft: '-50px',
            marginTop: '6px',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)',
            backdropFilter: 'blur(1px)',
            ...props.style
        }
        this. listener = (event) => {
            let r = this. ref2;
            if (this.state.isOpen && !r.current.contains(event.target)) {
                this.setState({ isOpen: false });
            }
        };
    }

    componentDidMount() {
        window.addEventListener('click',this. listener);
        window.addEventListener('touchstart', this. listener);
    }

    componentWillUnmount() {
        window.removeEventListener('click', this.listener);
        window.removeEventListener('touchstart', this.listener)
    }

    close = () => { this.setState({ isOpen: false }); }

    render() {
        return (
            <div ref={ this.ref2} className={`dropdown ${this.state.isOpen ? "open" : ""}`} style={{ display: 'inline-block' }}>
                <button onClick={() => this.setState({ isOpen:!this.state.isOpen })} className={this.props.className} >
                    {this.props.title}
                </button>
                <div className="menu" style={{ display: this.state.isOpen ? 'grid' : 'none', ...this.menu }}>
                    {this.props.children}
                </div>
            </div>);
    }
}


export default React.forwardRef((props, ref) => <Dropdown innerRef={ref} {...props} />);